<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Make Production Order",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, Loader },
  data() {
    return {
      title: "Production Order",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Order",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        destination: 0,
        product: "",
        unit: "",
        quantity: "",
        batch: "",
        manufacture_date: "",
        expiry_date: "",
        store: "",
        product_code: [],
      },
      itemError: "",
      quantityError: "",
      unitError: "",
      batch_noError: "",
      manufacture_dateError: "",
      expiry_dateError: "",
      totals: {
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        quantity: "",
        batch: "",
        manufacture_date: "",
        expiry_date: "",
      },
      limit: 0,
      balance: 0,
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      product_codes: [""],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("store", ["Stores"]),
    ...mapGetters("setting", ["ReceiptSettings", "GeneralSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapState("setting", ["general_settings"]),
    ...mapGetters("products", ["ProducedProducts"]),
    ...mapGetters("recipes", ["ProductionOrderCart", "SaveStatus"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product_name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "destination",
          sortable: true,
          label: "DESTINATION",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ];

      if (this.GeneralSettings && this.GeneralSettings.track_expiries == 1) {
        baseFields.splice(
          3,
          0,
          {
            key: "batch",
            sortable: true,
            label: "BATCH",
          },
          {
            key: "expiry_date",
            sortable: true,
            label: "EXPIRY",
          },
          {
            key: "manufacture_date",
            sortable: true,
            label: "MANUFACTURED DATE",
          },
        );
      }

      if (
        this.GeneralSettings &&
        this.GeneralSettings.allow_multiple_productcodes == 1
      ) {
        baseFields.splice(3, 0, {
          key: "product_code",
          sortable: true,
          label: "PRODUCT CODE(S)",
        });
      }
      return baseFields;
    },

    FilteredProducts() {
      const dest = this.data.destination;
      if (this.ProducedProducts) {
        if (dest == 1 || dest == 0) {
          return this.ProducedProducts.filter(
            (p) => p.category == 0 || p.category == 1,
          );
        } else {
          return this.ProducedProducts.filter(
            (p) => p.category == 2 || p.category == 3,
          );
        }
      }
      return this.ProducedProducts;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionOrderCart ? this.ProductionOrderCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    this.totalRows = this.ProductionOrderCart
      ? this.ProductionOrderCart.length
      : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetData();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    general_settings: {
      deep: true,
      handler(newVal) {
        if (newVal.multiple_stores == 1) {
          this.FetchStores();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      FetchCart: "recipes/fetchProductionOrderCart",
      AddCart: "recipes/addToProductionOrderCart",
      DeleteCartItem: "recipes/deleteProductionOrderCart",
      EditCartItems: "recipes/editProductionOrderCart",
      SaveOrderExit: "recipes/saveOrderExit",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchItems: "products/fetchProducedProducts",
      FetchStores: "store/fetchStores",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assignArr() {
      this.unitsArr = [];
      let selectedPdt = this.FilteredProducts.filter((product) => {
        return product.id == this.data.product;
      });
      this.unitsArr = selectedPdt[0].units;
      this.data.unit = this.unitsArr[0].id;
    },

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.ProductionOrderCart.filter((item) => {
          return item.product_id == this.data.product;
        });
        if (this.existingItem.length > 0) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.product = "";
      this.data.unit = "";
      this.unitsArr = [];
      this.data.batch = "";
      this.data.manufacture_date = "";
      this.data.expiry_date = "";
      this.data.quantity = "";
      this.data.product_code = "";
      this.product_code = [];
      this.existingItem = [];
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.expiry_date = "";
      this.editdata.batch = "";
      this.editdata.manufacture_date = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.unitError = "";
      this.CreditLimitError = "";
      this.quantityError = "";
      this.batch_noError = "";
      this.manufacture_dateError = "";
      this.expiry_dateError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.product_id;
      this.editdata.name = data.product_name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.expiry_date = data.expiry_date;
      this.editdata.batch = data.batch;
      this.editdata.manufacture_date = data.manufacture_date;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.product_name;
      this.deletedata.id = data.id;
    },

    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    // Validate manufacture date if set
    validateManufactureDate() {
      // Reset error
      this.manufacture_dateError = "";

      if (this.data.manufacture_date) {
        // Check if it's a valid date
        const manufactureDate = new Date(this.data.manufacture_date);
        if (isNaN(manufactureDate.getTime())) {
          this.manufacture_dateError = "Please enter a valid manufacture date";
          return false;
        }

        // If expiry date is set, compare dates
        if (this.data.expiry_date) {
          const expiryDate = new Date(this.data.expiry_date);
          if (manufactureDate > expiryDate) {
            this.manufacture_dateError =
              "Manufacture date cannot be later than expiry date";
            return false;
          }
        }
      }

      return true;
    },

    savePurchaseExit() {
      // Save Purchase
      this.SaveOrderExit(this.totals);
    },

    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Ordered is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (!this.validateManufactureDate()) {
        return;
      }
      if (this.data.batch != "" && this.data.expiry_date == "") {
        this.expiry_dateError = "Expiry Date is required";
        return;
      } else {
        this.expiry_dateError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
      this.resetData();
    },

    nextPlease() {
      document.getElementById("input2").focus();
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetErrors();
      });
    },

    checkAndAddField(index) {
      const lastIndex = this.product_codes.length - 1;
      // If current field has a value and it's the last field, add a new one
      if (index === lastIndex && this.product_codes[index].trim() !== "") {
        this.product_codes.push("");
      }
    },

    removeField(index) {
      this.product_codes.splice(index, 1);

      // Ensure at least one field remains
      if (this.product_codes.length === 0) {
        this.product_codes.push("");
      }
    },

    addCodes(modalId) {
      const codesArray = this.product_codes
        .map((code) => code.trim())
        .filter((code) => code !== "");
      this.data.product_code = codesArray;
      this.closeModal(modalId);
    },

    resetCodes() {
      this.product_codes = [""];
    },

    setInputRef(el, index) {
      if (!this.codeInputRefs) {
        this.codeInputRefs = {};
      }
      if (el) {
        this.codeInputRefs[index] = el;
      }
    },

    handleKey(index, event) {
      if (event.key === "Enter") {
        event.preventDefault();

        this.checkAndAddField(index);

        this.$nextTick(() => {
          this.$nextTick(() => {
            const nextInput = this.codeInputRefs[index + 1];
            if (nextInput && nextInput.focus) {
              nextInput.focus();
            }
          });
        });
      }
    },
  },
  created() {
    this.fetchReceiptSettings();
    this.FetchCart();
    this.FetchGeneralSettings();
    this.FetchItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ProductionOrderCart ? ProductionOrderCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(quantity_field)="data">
                  {{ data.item ? data.item.quantity : 0 }}
                  {{ data.item ? data.item.unitsym : 0 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i
                  ></b-button>
                  <b-button
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    class="m-2"
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i
                  ></b-button>
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ProductionOrderCart" />

            <b-form
              v-if="ProductionOrderCart && ProductionOrderCart.length > 0"
              class="mt-3"
            >
              <div class="row mt-4">
                <div
                  class="col-md-3"
                  v-if="
                    GeneralSettings.back_date_purchases == 1 &&
                    MyUserPerm.backdate_entries == 1
                  "
                >
                  <div class="form-group mb-3">
                    <label>Date</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                    />
                  </div>
                </div>
                <div
                  v-if="MyUserPerm.add_store_stock == 1"
                  class="col-md-3 mt-4"
                >
                  <b-button
                    variant="primary"
                    class="float-end"
                    v-if="SaveStatus"
                    disabled
                    ><i class="fa fa-check"></i> Save & Exit
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button
                    v-else
                    variant="primary"
                    class="float-end"
                    @click="savePurchaseExit()"
                    ><i class="fa fa-check"></i> Save & Exit
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">
              <div class="form-group mb-3">
                <label>Destination</label>
                <select class="form-control" v-model="data.destination">
                  <option value="0">Stock</option>
                  <option value="1">Store</option>
                  <option v-if="GeneralSettings.multiple_stores == 1" value="2">
                    Individual Store
                  </option>
                </select>
              </div>
              <div
                class="form-group mb-3"
                v-if="
                  GeneralSettings.multiple_stores == 1 && data.destination == 2
                "
              >
                <label>SEARCH BY STORE</label>
                <model-list-select
                  :list="
                    Stores ? [{ id: '', name: 'All Stores' }, ...Stores] : []
                  "
                  v-model="data.store"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Store"
                >
                </model-list-select>
              </div>
              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <model-list-select
                  :list="FilteredProducts ?? []"
                  v-model="data.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="resetErrors(), assignArr(), checkItem()"
                  @keyup.enter="nextPlease()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Quantity <span class="text-danger">*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      step="any"
                      id="input2"
                      v-model="data.quantity"
                      @input="resetErrors()"
                      placeholder="Enter Quantity"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Unit Measure <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="data.unit"
                      option-value="id"
                      :custom-text="
                        (unit) =>
                          unit ? unit.unitname: ''
                      "
                      placeholder="Select Unit"
                      @input="resetErrors()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="GeneralSettings.allow_multiple_productcodes == 1"
                class="form-group mb-3"
              >
                <label
                  >Product Code(s)
                  <span>
                    <b-button
                      size="sm"
                      style="font-size: 20px"
                      variant="link"
                      v-b-modal.add-code-modal
                    >
                      New
                    </b-button>
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.product_code"
                  @input="resetErrors()"
                  placeholder="Enter Product code"
                  @keyup.enter="addToCart()"
                />
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label>Batch Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.batch"
                  @input="resetErrors()"
                  placeholder="Enter Batch Number"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="batch_noError">
                  <em>{{ batch_noError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label>Manufactured Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.manufacture_date"
                  @input="resetErrors()"
                  @keyup.enter="addToCart()"
                  v-limit-future-date
                />
                <div class="text-danger" v-if="manufacture_dateError">
                  <em>{{ manufacture_dateError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label
                  >Expiry Date
                  <span v-if="data.batch != ''" class="text-danger"
                    >*</span
                  ></label
                >
                <input
                  type="date"
                  class="form-control"
                  v-model="data.expiry_date"
                  @input="resetErrors()"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="expiry_dateError">
                  <em>{{ expiry_dateError }}</em>
                </div>
              </div>
              <div class="form-group text-center">
                <b-button @click="addToCart()" variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal
      id="edit-item-modal"
      class="text-primary"
      hide-footer
      @hidden="resetEdit()"
    >
      <template #modal-title> Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Batch Number</label>
        <input type="text" class="form-control" v-model="editdata.batch" />
      </div>
      <div v-if="GeneralSettings.track_expiries == 1" class="form-group mb-3">
        <label>Manufactured Date</label>
        <input
          type="date"
          class="form-control"
          v-model="editdata.manufacture_date"
          v-limit-future-date
        />
      </div>
      <div class="form-group mb-3">
        <label>Expiry Date</label>
        <input
          type="date"
          class="form-control"
          v-model="editdata.expiry_date"
        />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal
      id="delete-item-modal"
      class="text-danger"
      hide-footer
      @hidden="resetDeleteItem"
    >
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- product codes modal starts-->
    <b-modal
      id="add-code-modal"
      hide-footer
      @hidden="resetCodes"
      :backdrop="'static'"
    >
      <template #modal-title> Add Product Codes </template>

      <div
        v-for="(code, index) in product_codes"
        :key="index"
        class="input-group mb-2"
      >
        <input
          v-model="product_codes[index]"
          @input="checkAndAddField(index)"
          @keydown="handleKey(index, $event)"
          class="form-control"
          :ref="(el) => setInputRef(el, index)"
        />
        <div class="input-group-append" v-if="product_codes.length > 1">
          <button
            class="btn btn-outline-danger"
            type="button"
            @click="removeField(index)"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-code-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary">
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            disabled
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addCodes('add-code-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- product codes modal ends -->

    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
